import { useQuery } from '@tanstack/react-query';
import { fetchFestivalSetIndex, fetchPastFestivalSets } from '../../api/festivalSets';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';

/** Upcoming festivals with a lineup, soonest first — the Sets index. */
export function useFestivalSets() {
  return useQuery({
    queryKey: queryKeys.sets.index(),
    queryFn: fetchFestivalSetIndex,
    staleTime: STALE.semiStatic,
  });
}

/** The festivals you went to that are over, latest first — the Sets index's Past. */
export function usePastFestivalSets(goingEventIds) {
  return useQuery({
    queryKey: queryKeys.sets.past(goingEventIds),
    queryFn: () => fetchPastFestivalSets(goingEventIds),
    enabled: goingEventIds.length > 0,
    staleTime: STALE.semiStatic,
  });
}
